export default __webpack_public_path__ + "static/media/maisons_laffitte15.ed28439b.jpg";